import React, { useState } from "react"
import { Grid, GridColumn as Column, GridDataStateChangeEvent } from '@progress/kendo-react-grid';
import { process, State } from "@progress/kendo-data-query";
import { ColumnMenu } from "../../../../../utils/ColumnMenu";
import { AccountSummary } from "../../../../../services/accountService/model";
import { AccountLookupCommandCell } from "./AccountLookupCommandCell";

type ownProps = {
    data: AccountSummary[]
}
function AccountLookupResults(props:ownProps){
    const [dataState, setDataState] = useState<State>({});
    const mapCases = ():AccountSummary[] => {
        return props.data.map(i => ({...i, serviceDate: new Date(i.serviceDate??'')}))
    }
    const createDataState = (dataState: State) => {
        return {
          dataState: dataState === undefined ? {} :dataState,};
      };
    const dataStateChange = (event: GridDataStateChangeEvent) => {
        let updatedState = createDataState(event.dataState);
        setDataState(updatedState.dataState);
      };

    return <React.Fragment>
        <Grid data={process(mapCases().slice(0),dataState)}{...dataState}
             style={{height:'500px'}} onDataStateChange={dataStateChange}>
                <Column cell={AccountLookupCommandCell} width={'75px'}/>
                <Column title='Account' field='accountNumber' columnMenu={ColumnMenu}/>
                <Column title='Name' field = 'patientName' columnMenu={ColumnMenu}/>
                <Column title='Service Date' field="serviceDate" format='{0:MM/dd/yyyy}' columnMenu={ColumnMenu}/>
                <Column title='Payer' field='payer' columnMenu={ColumnMenu}/>
                <Column title='Charges' field='charges' format='{0:c}' columnMenu={ColumnMenu}/>
                <Column title='AccruedRevenue' field='accruedRevenue' format='{0:c}' columnMenu={ColumnMenu}/>
        </Grid>
    </React.Fragment>
}
export {AccountLookupResults}